var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.9754,
    cy: 29.8043,
    r: 29.1981,
    fill: "#E8D6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.247 48.6417C27.6048 48.6417 30.3299 45.8286 30.3299 42.3625V36.0834H24.247C20.8892 36.0834 18.1641 38.8964 18.1641 42.3625C18.1641 45.8286 20.8892 48.6417 24.247 48.6417Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 29.8043C18.1641 26.3382 20.8892 23.5251 24.247 23.5251H30.3299V36.0835H24.247C20.8892 36.0835 18.1641 33.2704 18.1641 29.8043Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 17.246C18.1641 13.7799 20.8892 10.9668 24.247 10.9668H30.3299V23.5251H24.247C20.8892 23.5251 18.1641 20.7121 18.1641 17.246Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3281 10.9668H36.4111C39.7688 10.9668 42.494 13.7799 42.494 17.246C42.494 20.7121 39.7688 23.5251 36.4111 23.5251H30.3281V10.9668Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.494 29.8043C42.494 33.2704 39.7688 36.0835 36.4111 36.0835C33.0533 36.0835 30.3281 33.2704 30.3281 29.8043C30.3281 26.3382 33.0533 23.5251 36.4111 23.5251C39.7688 23.5251 42.494 26.3382 42.494 29.8043Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4976,
    height: 37.675,
    fill: "white",
    transform: "translate(12.0781 10.9668)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.e0ed28d4fb81a28fd8b8593921104d0e.svg";
export { ForwardRef as ReactComponent };